import { render } from "./veryAge.vue?vue&type=template&id=57bb1204&scoped=true"
import script from "./veryAge.vue?vue&type=script&lang=js"
export * from "./veryAge.vue?vue&type=script&lang=js"

import "./veryAge.vue?vue&type=style&index=0&id=57bb1204&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bb1204"]])

export default __exports__